import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import classNames from 'classnames'

import Link from 'base/react/components/link'
import MenuTiles from 'base/components/layout/menu_tiles'

const SALE_MENU_ITEMS = ['FINAL SALE', 'SALE']

export function ThirdLevelMenu({
  disabled,
  name,
  onClickItem,
  onMouseEnterItem,
  opens_in_new_window,
  url,
  color,
  isHeading = false,
}) {
  const linkTarget = opens_in_new_window ? '_blank' : '_self'
  const TagName = isHeading ? 'div' : 'li'

  const defaultThirdLevelEventProperties = {
    url,
    name,
  }

  return (
    <TagName className="drop-down-menu__third-level-menu">
      <Link
        className={classNames({
          'everlane-brand-link--disabled': disabled,
          'everlane-brand-link--important': SALE_MENU_ITEMS.includes(name.toUpperCase()),
          'everlane-brand-link--heading': isHeading,
          'drop-down-menu__third-level-menu--custom-color': color,
        })}
        style={{ color }}
        href={url}
        onClick={() => onClickItem(defaultThirdLevelEventProperties)}
        onMouseEnter={event => onMouseEnterItem(event, defaultThirdLevelEventProperties)}
        target={linkTarget}
      >
        {name}
      </Link>
    </TagName>
  )
}

export function SecondLevelMenu({
  url,
  name,
  onClickItem,
  onMouseEnterItem,
  submenus,
  currentPath,
  color,
}) {
  const menuHeader = (
    <ThirdLevelMenu
      disabled={!url}
      onClickItem={onClickItem}
      onMouseEnterItem={onMouseEnterItem}
      isActive={url === currentPath}
      name={name}
      url={url}
      isHeading={true}
      color={color}
    />
  )
  const regularSubmenus = submenus.map(submenu => (
    <ThirdLevelMenu
      onClickItem={onClickItem}
      onMouseEnterItem={onMouseEnterItem}
      key={submenu.id}
      isActive={submenu.url === currentPath}
      {...submenu}
    />
  ))

  return (
    <div className="drop-down-menu__second-level-menu">
      <div className="drop-down-menu__third-level-header">{menuHeader}</div>

      <ul>{regularSubmenus}</ul>
    </div>
  )
}

function DropdownMenu({
  currentPath,
  leftAlign,
  menus,
  menuName,
  onClickItem,
  onMouseEnterItem,
  images,
  isVisible = false,
}) {
  const innerClass = classNames(
    'drop-down-menu__inner-container',
    `drop-down-menu__inner-container-${menus.length}`,
    {
      'drop-down-menu__inner-container--left-align': leftAlign,
    },
  )

  return (
    <nav className="drop-down-menu" hidden={!isVisible}>
      <div className={innerClass} data-cy={`dropdown-menu-${menuName.toLowerCase()}`}>
        <Fragment>
          {menus.map(menu => (
            <SecondLevelMenu
              onClickItem={onClickItem}
              onMouseEnterItem={onMouseEnterItem}
              key={menu.id}
              currentPath={currentPath}
              {...menu}
            />
          ))}
          <MenuTiles
            menuImageItems={images}
            onClick={onClickItem}
            onMouseEnter={onMouseEnterItem}
          />
        </Fragment>
      </div>
    </nav>
  )
}

DropdownMenu.propTypes = {
  currentPath: PropTypes.string,
  menus: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuName: PropTypes.string.isRequired,
  onClickItem: PropTypes.func,
  onMouseEnterItem: PropTypes.func,
  // mark as required once on builder menus
  images: PropTypes.arrayOf(PropTypes.object),
}

SecondLevelMenu.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  submenus: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentPath: PropTypes.string,
  onClickItem: PropTypes.func,
  onMouseEnterItem: PropTypes.func,
  disabled: PropTypes.bool,
}

ThirdLevelMenu.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClickItem: PropTypes.func,
  onMouseEnterItem: PropTypes.func,
  opens_in_new_window: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default DropdownMenu
